<template>
    <div class="kv-switch-wrapper d-flex align-items-center gap-xl">
        <label class="switch">
            <input type="checkbox" :id="id" :checked="isChecked" @change="onChange">
            <span class="slider"></span>
        </label>

        <KvTypography size="large" color="secondary">{{ label }}</KvTypography>
    </div>
</template>

<script>
import KvTypography from "../ui/kv-typography.vue";

export default {
    name: "KvSwitch",
    components: { KvTypography },

    props: {
        id: String,
        value: { default: false },
        label: { type: String, default: "" },
        returnType: {
            type: String,
            default: "boolean",
            validator: (v) => ["boolean", "number"].includes(v)
        },
        // size: {
        //     type: String,
        //     default: "regular",
        //     validator: (v) => ["regular", "large", "extra-large"].includes(v)
        // }
    },
    computed: {
        isChecked() {
            return this.value === true || this.value == 1; // Pode ser "1" ou 1
        }
    },
    methods: {
        onChange(e) {
            const boolValue = e.target.checked;
            const output =
                this.returnType === "number"
                    ? (boolValue ? 1 : 0)
                    : boolValue;

            this.$emit("input", output);
        }
    }
};
</script>


<style lang="scss">
/* From Uiverse.io by alexruix */
/* The switch - the box around the slider */
.kv-switch-wrapper {
    .switch {
        font-size: 17px;
        position: relative;
        display: inline-block;
        width: 48px;
        height: 22px;
        margin: 0 !important;


        /* Hide default HTML checkbox */
        input {
            opacity: 0;
            width: 0;
            height: 0;
        }

        /* The slider */
        .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #FFFFFF;
            border: 1px solid #F3F4F6;
            transition: .4s;
            border-radius: 4.8px;
            outline: none;

            &:before {
                position: absolute;
                content: "";
                border-radius: 3.6px;
                outline: 1px solid #9DA4AE;
                background-color: #D2D6DB;
                transition: transform .25s ease-in-out 0s;
                left: 5%;
                top: 50%;
                transform: translateY(-50%);
                height: 80%;
                width: 40%;
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
            }
        }

        input:checked+.slider {
            background-color: #D3F8E0;
            border-color: #17B26A;

            &:before {
                outline-color: #097347;
                background-color: #17B26A;
                transform: translate(120%, -50%);
            }
        }
    }
}
</style>
